import { monthsNames } from "./constants";

export function formatCurrency(amount) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(amount / 100)
}

export function formatPhone(phone) {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (phone && phoneRegex.test(phone)) {
        return phone.replace(phoneRegex, "($1) $2-$3");
    }
    return phone;
}

export function formatDate(millis) {
    const date = new Date(millis);
    return `${monthsNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}
